/* Product page extras: "Make it a pair" bundle (add both hats at once) */
(function () {
  var box = document.getElementById('pdp-bundle');
  if (!box) return;
  var pct = parseFloat(box.dataset.pct) || 0;
  var base = parseInt(box.dataset.base, 10) || 0;
  var fmt = box.dataset.money || '${{amount}}';
  function money(c) {
    var n = (c / 100).toFixed(2), parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole).replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]).replace(/<[^>]+>/g, '');
  }
  var opts = [].slice.call(box.querySelectorAll('.pb__opt'));
  var was = box.querySelector('[data-pb-was]'), now = box.querySelector('[data-pb-now]');
  var addBtn = box.querySelector('[data-pb-add]'), label = box.querySelector('[data-pb-label]');
  function current() { return opts.filter(function (o) { return o.classList.contains('is-on'); })[0] || opts[0]; }
  function price() {
    var o = current(); if (!o) return;
    var total = base + (parseInt(o.dataset.price, 10) || 0);
    var after = Math.round(total * (1 - pct / 100));
    was.textContent = pct ? money(total) : ''; now.textContent = money(after);
  }
  opts.forEach(function (o) {
    o.addEventListener('click', function () {
      opts.forEach(function (x) { var on = x === o; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      price();
    });
  });
  /* keep the first hat in sync with the variant picked on the page */
  var vInput = document.getElementById('pdp-variant-id');
  function baseId() { return (vInput && vInput.value) || box.dataset.baseId; }
  addBtn.addEventListener('click', function () {
    var o = current(); if (!o || addBtn.disabled) return;
    var orig = label.textContent; addBtn.disabled = true; label.textContent = 'Adding\u2026';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +baseId(), quantity: 1 }, { id: +o.dataset.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        label.textContent = 'Added \u2713';
        if (typeof window.refreshCart === 'function') window.refreshCart();
        if (typeof window.openCart === 'function') window.openCart();
        setTimeout(function () { label.textContent = orig; addBtn.disabled = false; }, 1800);
      })
      .catch(function () { label.textContent = orig; addBtn.disabled = false; });
  });
  price();
})();

/* Delivery estimate: "Order today, arrives Thu, Oct 15 - Mon, Oct 19" (business days, skipping weekends) */
(function () {
  var el = document.getElementById('pdp-eta');
  if (!el) return;
  var d = el.dataset, now = new Date();
  function addBusinessDays(date, n) {
    var x = new Date(date.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  var start = new Date(now.getTime());
  var w = start.getDay(), late = now.getHours() >= (parseInt(d.cutoff, 10) || 12);
  if (w === 0 || w === 6 || late) start = addBusinessDays(start, 1);   /* weekend or after cut-off: starts next business day */
  var pmin = +d.pmin || 0, pmax = Math.max(+d.pmax || 0, pmin), smin = +d.smin || 1, smax = Math.max(+d.smax || 1, smin);
  var first = addBusinessDays(start, pmin + smin), last = addBusinessDays(start, pmax + smax);
  var f = function (x) { return x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
  var range = first.toDateString() === last.toDateString() ? f(first) : f(first) + ' \u2013 ' + f(last);
  el.querySelector('[data-eta-text]').innerHTML = (late || w === 0 || w === 6 ? 'Order now' : 'Order today') + ', arrives <strong>' + range + '</strong>';
  el.hidden = false;
})();

